import React, { createContext, useState } from "react";
import { AppEvents } from "../services/resources/AppEvents";
import {
  login,
  LoginInput,
  UserAuthResponseOrNull,
  register,
  RegisterInput,
  profile,
  UserDto,
  RecoverPassword,
  registerNewPassword
} from "../services/resources/user";

interface AuthContextProps {
  user: UserDto | null;
  getCurrentUser: () => Promise<UserDto>;
  auth: UserAuthResponseOrNull;
  onLogin: (params: LoginInput) => Promise<UserDto>;
  onLogout: () => void;
  onRegister: (params: RegisterInput) => Promise<UserDto>;
  onRegisterNewPassword: (params: RecoverPassword) => Promise<UserDto>;
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const defaultAuth = localStorage.getItem("auth")
  ? JSON.parse(localStorage.getItem("auth")!)
  : null;

export const AuthContext = createContext<AuthContextProps>(
  {} as AuthContextProps
);

export const AuthProvider: React.FC<Props> = ({ children }) => {
  const [auth, setAuth] = useState<UserAuthResponseOrNull>(defaultAuth);

  const [user, setUser] = useState<UserDto | null>(() => {
    const user = localStorage.getItem("@Auth:User");

    if (user) {
      return JSON.parse(user);
    }

    return {} as UserDto;
  });

  const handleLogin = async (params: LoginInput) => {
    try {
      const { data } = await login(params);

      if (data?.status === "error") {
        return data;
      }

      if (data?.accessToken) {
        localStorage.setItem("@Auth:Token", data.accessToken);
      }
      return getCurrentUser();
    } catch (error) {
      console.log("error")
    }
  };

  const getCurrentUser = async () => {
    const { data } = await profile();
    setUser(data);
    localStorage.setItem("@Auth:User", JSON.stringify(data));
    return data as UserDto;
  };

  const handleLogout = () => {
    localStorage.removeItem("@Auth:Token");
    localStorage.removeItem("@Auth:User");
    setAuth(null);
    setUser(null);
    setTimeout(() => {
      window.location.reload();
      localStorage.removeItem("@Auth:Token");
      localStorage.removeItem("@Auth:User");
    }, 500);
  };

  AppEvents.getInstance().on("logout", handleLogout);

  const handleRegister = async (params: RegisterInput) => {
    try {
      const { data } = await register(params);
      localStorage.setItem("@Auth:TOken", data.accessToken);
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  const handleRegisterNewPassword = async (params: RecoverPassword) => {
    try {
      const { data } = await registerNewPassword(params);
      localStorage.setItem("@Auth:TOken", data.accessToken);
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  const value = {
    user,
    getCurrentUser,
    auth,
    onLogin: handleLogin,
    onLogout: handleLogout,
    onRegister: handleRegister,
    onRegisterNewPassword: handleRegisterNewPassword,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
